<template>
  <AuthForm
    v-model="formData"
    title="Reset password"
    description="Enter your new password below"
    :rules="rules"
    @submit="handleSubmit"
  >
    <div class="form-row mb-20px">
      <ElFormItem prop="password" class="full-width">
        <AppInput
          v-model="formData.password"
          label="New password"
          placeholder="Enter new password"
          type="password"
          :required="true"
        />
      </ElFormItem>
    </div>

    <div class="form-row mb-20px">
      <ElFormItem prop="passwordConfirmation" class="full-width">
        <AppInput
          v-model="formData.passwordConfirmation"
          label="Confirm password"
          placeholder="Confirm new password"
          type="password"
          :required="true"
        />
      </ElFormItem>
    </div>

    <template #footer>
      <div class="d--f jc--c full-width mt-20px">
        <div>
          Remember your password? <router-link :to="{ name: 'login' }" class="router-link-plain">Sign in</router-link>
        </div>
      </div>
    </template>
  </AuthForm>
</template>

<script setup>
import { reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElFormItem } from "element-plus";
import { AppInput } from "@/components/ui";

import AuthApi from "@/api/auth";
import AuthForm from "@/views/Auth/components/AuthForm.vue";
import { showToast } from "@/utilities/toast";
import { formatErrorMessages } from "@/utilities/errors";

const route = useRoute();
const router = useRouter();

const formData = reactive({
  password: "",
  passwordConfirmation: "",
});

const rules = {
  password: [
    { required: true, message: "Please enter a password", trigger: "blur" },
    { min: 8, message: "Password must be at least 8 characters long", trigger: "blur" },
  ],
  passwordConfirmation: [
    { required: true, message: "Please confirm password", trigger: "blur" },
    {
      validator: (_, value, callback) => {
        value !== formData.password ? callback(new Error("Passwords don't match")) : callback();
      },
      trigger: "blur",
    },
  ],
};

const handleSubmit = async () => {
  const response = await AuthApi.resetPassword(
    route.query.reset_password_token,
    formData.password,
    formData.passwordConfirmation
  );

  if (response.data.errors) {
    showToast(formatErrorMessages(response.data.errors), { type: "error" });
  } else {
    showToast("Password reset successful!", { type: "success" });
    router.push({ name: "reports" });
  }
};
</script>
